import ClearInputButton from "./ClearInputButton";

export default ClearInputButton;